// Fire Danger Index (DAFF Lowveld Model) category helpers.
// Buckets: 0–20 Safe, 21–45 Moderate, 46–60 Dangerous, 61–75 Very Dangerous, 76+ Extremely Dangerous.
//
// Returns a unified shape used by the banner, daily cards, hourly table,
// and the manual calculator so a single source of truth drives every
// "what colour is this number" decision on the page.

const CATEGORIES = [
  { max: 20,        level: 'Safe',               color: '#2196f3', colorCode: 'Blue',   advice: 'Safe to burn under permit.' },
  { max: 45,        level: 'Moderate',           color: '#4caf50', colorCode: 'Green',  advice: 'Burn with caution.' },
  { max: 60,        level: 'Dangerous',          color: '#ffc107', colorCode: 'Yellow', advice: 'Do not burn without authority approval.' },
  { max: 75,        level: 'Very Dangerous',     color: '#ff9800', colorCode: 'Orange', advice: 'Do not burn — high risk of escape.' },
  { max: Infinity,  level: 'Extremely Dangerous', color: '#f44336', colorCode: 'Red',   advice: 'No burning. Extreme fire conditions.' },
];

const UNKNOWN = { level: 'Unknown', color: '#9e9e9e', colorCode: 'Gray', advice: 'No forecast data available.' };

export const fdiCategory = (fdi) => {
  if (fdi == null) return UNKNOWN;
  return CATEGORIES.find((c) => fdi <= c.max) || UNKNOWN;
};

// Convenience accessors.
export const fdiLevel = (fdi) => fdiCategory(fdi).level;
export const fdiColor = (fdi) => fdiCategory(fdi).color;
export const fdiAdvice = (fdi) => fdiCategory(fdi).advice;

// Pick a text colour that stays legible against the category background.
// Yellow + Green need black text; the rest get white.
export const fdiTextOn = (fdi) => {
  const c = fdiCategory(fdi).color;
  return c === '#ffc107' || c === '#4caf50' ? '#000' : '#fff';
};
